import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";

export const removeAdvisorFromCache = (
	cached: AssignedAgentsQueryData | undefined,
	advisorId: number,
) =>
	cached
		? {
				...cached,
				data: cached.data.filter((advisor) => advisor.id !== advisorId),
				meta: {
					...cached.meta,
					totalCount: Math.max(0, cached.meta.totalCount - 1),
				},
			}
		: undefined;
